import './workShowCase.styles.scss';
const WorkShow = () => {
    return (

       <div className='workShow' id="work">
        <div className='heading'>
            <h1>OUR WORK</h1>
        </div>
        <div className='work-heading'>
            <h2>1. Dk-clothing Ecommerce</h2>
        </div>
        <div className='workShow-container'>
            <div className='work1'>
                <div className='work1-top'>

                </div>
                <div className='work1-bottom'>
                    <div className='work1-bleft'></div>
                    <div className='work1-bright'></div>
                </div>
            </div>
            <div className='work-heading'>
            <h2>2. Educera -  Current Project</h2>
            </div>
             <div className='work2'>
                 <div className='work2-top'>
                    
                </div>
                <div className='work2-bottom'>
                    <div className='work2-bleft'></div>
                    <div className='work2-bright'></div>
                </div>
            </div>
            <div className='work-heading'>
            <h2>3. Personal Portfolio</h2>
        </div>
             <div className='work3'>
                 <div className='work3-top'>
                    
                </div>
                <div className='work3-bottom'>
                    <div className='work3-bleft'></div>
                    <div className='work3-bright'></div>
                </div>
            </div>
        </div>

       </div>
    )
}


export default WorkShow;